import {useState } from "react";
import PLPMobileSwatches from "../common/PLPMobileSwatches";
import styles from "../QuickBuyComp/QuickBuyComp.module.scss";


export default function QuickBuyLite(props) {
    const [product,setProduct] = useState({});
    const [variants, setVariants] = useState({});
    return (
        <div className={`quick_buy dark ${styles.quick_buy} ${styles.qb_open} hide-options`}>
            <PLPMobileSwatches 
                data={variants.sizes}
                handle={props.product_handle}
                setVariants={setVariants}
                setProduct={setProduct}
                product={product}
                variants={variants}
                productImage={props.productImage}
                badge_curated={props.badge_curated}
                search={props.searchComp}
                objectId={props.objectID}
                queryId={props.queryId}
                device={props.device}
            />
        </div>
    )
}